const state = {
  eimsUserInfArticles: []
}

const mutations = {
  getArticlesInfo(state, obj){
    state.eimsUserInfArticles = obj.eimsUserInfArticles;
  },
  clearEimsUserInfArticles(state){
    state.eimsUserInfArticles = [];
  }
}

const actions = {
  getArticlesInfo:({commit, state}, obj) => commit("getArticlesInfo", obj),
  clearEimsUserInfArticles:({commit, state}, obj) => commit("clearEimsUserInfArticles", obj),

}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/articleInfoModule.js